const pie = (data) => {
  const defaultConfig = {
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        type: 'pie',
        radius: '50%',
        data,
      }
    ]
  }

  const opt = Object.assign({}, defaultConfig)
  return opt
}

export default {
  pie
}